import { normalize } from "normalizr"
import { push } from "react-router-redux"

import * as schemas from "../schemas"

import { getUserRole, getTranslationsByScope, DropitState } from "../reducers"

import { $deleteProducts, $getRawProductList } from "../requests"

import { startLoading, stopLoading } from "."
import { ActionTypes } from "./act_types"
import { toastr } from "react-redux-toastr"
import {
  convertReceivedProduct,
  IRawSupplierReference,
} from "../../models/product/product"
import { isDroopyGuid } from "../../utils"

export const selectRow = (droopyId: string) => ({
  droopyId,
  type: ActionTypes.SELECT_ROW,
})

export const unselectRow = (droopyId: string) => ({
  droopyId,
  type: ActionTypes.UNSELECT_ROW,
})

export const selectAllRows = (ids: string[]) => ({
  ids,
  type: ActionTypes.SELECT_ALL_ROWS,
})

export const unselectAllRows = () => ({
  type: ActionTypes.UNSELECT_ALL_ROWS,
})

// The loading in progress, and a reload queued behind it. A reload requested while a loading is running (e.g. right
// after a creation, a validation or an activation) used to be dropped: the list then kept the data read before the
// change (FE-TECH-R11).
let currentProductsLoad: Promise<boolean> | null = null
let queuedProductsLoad: Promise<boolean> | null = null

export const fetchProducts =
  () => (dispatch: (callback: object) => any, getState: () => DropitState): Promise<boolean> => {
    if (currentProductsLoad) {
      if (!queuedProductsLoad) {
        queuedProductsLoad = currentProductsLoad.then(() => {
          queuedProductsLoad = null
          return dispatch(fetchProducts() as any) as Promise<boolean>
        })
      }
      return queuedProductsLoad
    }
    currentProductsLoad = loadProducts(dispatch, getState).finally(() => {
      currentProductsLoad = null
    })
    return currentProductsLoad
  }

const loadProducts = (
  dispatch: (callback: object) => any,
  getState: () => DropitState
): Promise<boolean> => {
    const role = getUserRole(getState())

    dispatch({
      type: ActionTypes.START_FETCHING_PRODUCTS,
    })

    const toastrTranslations = getTranslationsByScope(
      getState(),
      "toastrLabels"
    )
    const errorTranslations = getTranslationsByScope(getState(), "fieldErrors")
    return $getRawProductList(role, toastrTranslations)
      .then((rawResponse: IRawSupplierReference[]) => {
        const response: IRawSupplierReference[] = rawResponse
          .map(convertReceivedProduct)
          .sort((a: IRawSupplierReference, b: IRawSupplierReference) =>
            a.droopyId > b.droopyId ? 1 : -1
          )
        dispatch({
          response: normalize(response, schemas.arrayOfProducts),
          type: ActionTypes.FETCH_PRODUCTS_SUCCESS,
        })
        return true
      })
      .catch((err) => {
        dispatch({
          errorMessage: err.message,
          type: ActionTypes.FETCH_PRODUCTS_FAIL,
        })
        return true
      })
  }

export const goToProduct = (droopyId: string, declinedId?: string) =>
  declinedId
    ? push("/product_form/" + droopyId + "/" + declinedId)
    : push("/product_form/" + droopyId)

export const goToProductList = () => push("/product_list")

export interface IFileInfos {
  path: string
  name: string
}

export const handleShowDeletedProductsChange = () => ({
  type: ActionTypes.SHOW_DELETED_PRODUCTS,
})

// export const deleteProducts =
//   (ids: string[]) =>
//   (dispatch: (callback: object) => void, getState: () => DropitState) => {
//     dispatch(startLoading())
//     const role = getUserRole(getState())
//     return $deleteProducts(ids, role)
//       .then(() => {
//         dispatch({
//           ids,
//           type: ActionTypes.DELETE_PRODUCTS,
//         })
//       })
//       .catch((err) => {
//         toastr.error(err.message ? err.message : "error", "")
//         return err
//       })
//       .finally(() => {
//         dispatch(stopLoading())
//       })
//   }
